import { createContext } from 'react';

export const ActiveCatalogueProductListMeta = createContext({
  activeProductListMeta: {},
  setActiveProductListMeta: () => {}
});
